import { Box, Skeleton, Typography, useTheme } from '@mui/material'
import { useTranslation } from 'react-i18next'

import { Loader, ModalWrapper } from 'src/components'

import { useStyles } from '../styles'
import { useGetApprovalFeedbacksByIds } from 'src/hooks/approval-feedbacks/use-get-approval-feesbacksby-ids.hook'

interface IProps {
  open: boolean
  handleClose: () => void
  itemsId: string[] | null
}

export const ApprovalFeedbackModal = ({ open, handleClose, itemsId }: IProps) => {
  const [t] = useTranslation()
  const classes = useStyles()
  const theme = useTheme()

  const { data, isLoading } = useGetApprovalFeedbacksByIds(itemsId || [])

  return (
    <ModalWrapper
      open={open}
      onClose={() => {
        handleClose()
      }}
      className={classes.declineInfoModal}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',

          gap: '12px',
        }}
      >
        <Typography
          sx={{
            color: theme.palette.custom.darkBlue2,
            fontSize: '18px',
            fontWeight: 600,
            width: '100%',
            textAlign: 'center',
            mb: '10px',
          }}
        >
          Feedback for Improvement
        </Typography>

        <Box
          sx={{
            width: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '6px',
            flexDirection: 'column',
          }}
        >
          {data ? (
            data.map((item) => (
              <Box
                sx={{
                  width: '100%',
                  backgroundColor: theme.palette.grey[100],
                  padding: theme.spacing(1),
                  borderRadius: '8px',
                }}
              >
                <Typography
                  variant="body2"
                  sx={{
                    color: theme.palette.custom.darkBlue2,
                  }}
                >
                  {item.text}
                </Typography>
              </Box>
            ))
          ) : (
            <Skeleton
              width={'100%'}
              height={'50px'}
              variant="rectangular"
              sx={{ borderRadius: '5px' }}
            />
          )}
        </Box>
      </Box>
    </ModalWrapper>
  )
}
